import React, { useRef } from 'react'
import { 
  Container,
  FormControl,
  FormLabel,
  Input,
  IconButton,
  Button,
  ButtonGroup,
  useToast,
  ListItem,
  OrderedList,
  Heading,
  Box
} from '@chakra-ui/react'
import { FaArrowLeft } from "react-icons/fa6";
import './Setting.css'
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { useDispatch, useSelector } from 'react-redux';
import { updateGoogleSetting } from '@Stores/googleSetting';
import { updateScanRecord } from '@Stores/scanRecord';

const Setting = () => {
  let tokenClient;
  const toast = useToast()
  const dispatch = useDispatch()
  const googleSheetSetting = useSelector(state => state.googleSetting.value)
  const record = useSelector(state => state.scanRecord.value)
  const gapiErrorMessage = useRef(null)

  const navigate = useNavigate()
  const { 
    reset,
    register, 
    handleSubmit,
    watch, 
    trigger,
    setValue,
    formState: {errors} 
  } = useForm({
    defaultValues: {
      ...googleSheetSetting,
      password: '',
    }
  })

  async function initializeGapiClient() {
    try {
      await window.gapi.client.init({
        apiKey: watch('apiKey'),
        discoveryDocs: ['https://sheets.googleapis.com/$discovery/rest?version=v4'],
      });
    } catch(err) {
      console.log(err);
      gapiErrorMessage.current = "API 金鑰錯誤"
      return;
    }
  }

  function gapiLoaded() {
    window.gapi.load('client', initializeGapiClient);
  }

  function gisLoaded() {
    tokenClient = window.google.accounts.oauth2.initTokenClient({
      client_id: watch('clientID'),
      scope: 'https://www.googleapis.com/auth/spreadsheets',
      ux_mode: 'popup',
      callback: async (resp) => {
        if (resp.error !== undefined) {
          throw (resp);
        }
        await listMajors();
      },
    });
  }

  async function listMajors() {
    let response;
    try {
      response = await window.gapi.client.sheets.spreadsheets.values.get({
        spreadsheetId: watch('sheetID'),
        range: watch('sheetName') === '' ? 'A1:Z' : `${watch('sheetName')}!A1:Z`,
      });
    } catch (err) {
      if (gapiErrorMessage.current === null) {
        gapiErrorMessage.current = err.status === 400 ? '分頁名錯誤' : 'Google Sheet ID 錯誤'
      }
      toast({
        title: '欄位資訊錯誤',
        description: gapiErrorMessage.current ?? '例外錯誤',
        status: 'error',
        duration: 2000,
        position: 'top',
        isClosable: true,
      })
      gapiErrorMessage.current = null
      return;
    }
    const range = response.result;
    // 在Google sheet資料的最後加上備註、盤點狀態、盤點時間
    const initScanData = range.values.map((sheetRow, index) => {
      if (index === 0) return ['盤點狀態', '盤點時間' , ...sheetRow]
      return ['尚未盤點', '',...sheetRow, '']
    })

    dispatch(updateScanRecord(initScanData))
    
    if (!range || !range.values || range.values.length == 0) {
      toast({
        title: '連線成功',
        description: '您的工作表中沒有任何資料',
        status: 'warning',
        duration: 2000,
        position: 'top',
        isClosable: true,
      })
      return;
    }
    toast({
      title: '連線成功',
      status: 'success',
      duration: 2000,
      position: 'top',
      isClosable: true,
    })
  } 

  const importGoogleSheet = () => {
    if (watch('clientID') === '') return toast({
      title: '欄位資訊錯誤',
      description: "ClientID 為必填欄位",
      status: 'error',
      duration: 2000,
      position: 'top',
      isClosable: true,
    })
    gapiLoaded()
    gisLoaded()
    
    if (window.gapi.client.getToken() === null) {
      tokenClient.requestAccessToken({prompt: 'consent'});
    } else {
      tokenClient.requestAccessToken({prompt: ''});
    }
  }

  const onSubmit = (data) => {
    console.log(data);
    const { password, ...googleSetting } = data
    if (password !== 123) {
      trigger('password')
      return;
    };
    setValue('password', "")
    toast({
      title: '儲存成功',
      status: 'success',
      duration: 2000,
      position: 'top',
      isClosable: true,
    })
    dispatch(updateGoogleSetting(googleSetting))
  }

  return (
    <div className='setting'>
      <div className='navbar'>
        <p style={{color: 'white', fontSize: '1.5rem'}}>Funcode</p>
      </div>
      <Container pt='1rem'>
        <IconButton
          display='block'
          isRound={true}
          variant='solid'
          backgroundColor='transparent'
          aria-label='GoBack'
          fontSize='20px'
          _hover={{
            backgroundColor: 'transparent',
            color: '#bababa'
          }}
          onClick={() => navigate('/home')}
          icon={<FaArrowLeft />}
        />
        <form onSubmit={handleSubmit(onSubmit)}>
          <FormControl mt='.5rem'>
            <FormLabel>用戶端 ID</FormLabel>
            <Input 
              type='text'
              {...register('clientID')} 
            />
          </FormControl>
          <FormControl mt='.5rem'>
            <FormLabel>API 金鑰</FormLabel>
            <Input 
              type='text' 
              {...register('apiKey')} 
            />
          </FormControl>
          <FormControl mt='.5rem'>
            <FormLabel>Google Sheet ID</FormLabel>
            <Input 
              type='text' 
              {...register('sheetID')} 
            />
          </FormControl>
          <FormControl mt='.5rem'>
            <FormLabel>分頁名(選填)</FormLabel>
            <Input 
              type='text' 
              {...register('sheetName')} 
            />
          </FormControl>
          <FormControl mt='.5rem' isInvalid={!!errors.password}>
            <FormLabel>儲存設定密碼</FormLabel>
            <Input 
              type='text' 
              {...register('password', {
                valueAsNumber: true,
                validate: {
                  password: v => v === 123 || '儲存時必須輸入密碼'
                }
              })} 
            />
            <ErrorMessage 
              errors={errors} 
              name="password"
              render={({message}) => 
                <p style={{color: '#ff5252', fontWeight: 700}}>{message}</p>
              } 
            />
          </FormControl>
          <ButtonGroup 
            width='100%' 
            justifyContent='space-between'
            mt='1rem'
          >
            <Button 
              width='50%'
              colorScheme='blue'
              type='submit'
            >
              儲存修改
            </Button>
            <Button width='50%' onClick={() => reset()}>取消修改</Button>
          </ButtonGroup>
        </form>
        <Button
          width='100%'
          mt='1rem'
          onClick={importGoogleSheet}
        >
          匯入Sheet資料
        </Button>
        <div className='import-card'>
          {record.length > 0 && record.filter((_, index) => index !== 0).map((data, index) =>
            <div className='import-data' key={index}>
              {data.map((d,index) => 
                <p key={d+index}>
                  <span style={{ fontWeight: 700 }}>{record[0][index]}</span> : {d}
                </p>
              )}
            </div>
          )}
        </div>
        {/* <Heading as='h3' size='md' mt='1rem'>注意事項</Heading>
        <OrderedList>
          <ListItem>未指定分頁名，預設匯入第一頁的工作表</ListItem>
          <ListItem>若未儲存連線 Google Sheet 的欄位資訊就離開此頁，匯入資料將自動移除</ListItem>
        </OrderedList> */}
      </Container>
    </div> 
  )
}

export default Setting